import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Logo from "../assets/LogoNew2.png";
import { AiFillHome } from "react-icons/ai";
import { IoMdAdd, IoIosPeople } from "react-icons/io";
import {
  MdAccountBalance,
  MdNotifications,
  MdApartment,
  MdAssignment,
} from "react-icons/md";
import { GoGitPullRequest } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import {
  Engineering,
  Logout,
  Person,
  Settings,
  Payment,
  Lock,
  Wallet,
} from "@mui/icons-material";
import Container from "@mui/material/Container";
import { useState, useMemo, useEffect } from "react";
import { Avatar, Menu, MenuItem, Tooltip } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { toggleSidebar, setSidebarOpen } from "../redux/reducer/SidebarSlice";
import LogoutDialog from "./LogoutDialog";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import { MdSettings } from "react-icons/md";
import OwnerWrapper from "./OwnerWrapper";

// import { FaPeopleGroup } from 'react-icons/fa';
const drawerWidth = 240;

/**
 * Every owner screen imports this file, so the redesigned owner shell is
 * switched in here instead of in 26 different pages. The tenant and admin
 * branches of the original sidebar below are untouched — they are still the
 * fallback for anyone who reaches a page through this wrapper.
 */
export default function Wrapper({ mylocation }) {
  const { validateUser } = useSelector((state) => state);
  const userType = validateUser?.UserValidate?.data?.user?.type;

  if (userType === "landlord") return <OwnerWrapper />;

  return <LegacyWrapper mylocation={mylocation} />;
}

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    [theme.breakpoints.up("md")]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  // On mobile, AppBar always takes full width
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
  },
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function LegacyWrapper({ mylocation }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sidebar.open);
  mylocation = location.pathname;
  const { loginUser, validateUser } = useSelector((state) => state);
  const user = validateUser?.UserValidate?.data?.user;
  const [openDialog, setOpenDialog] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const toogle = Boolean(anchorEl);
  const [anchorNotif, setAnchorNotif] = useState(null);
  const notifOpen = Boolean(anchorNotif);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const handleNotifClick = (event) => {
    setAnchorNotif(event.currentTarget);
  };

  const handleNotifClose = () => {
    setAnchorNotif(null);
    // navigate("/notifications");
  };
  //   const handleDrawerOpen = () => {
  //     setOpen(true);
  //   };
  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(toggleSidebar());
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const unreadCount = useMemo(() => {
    const list = user?.notifications || [];
    return list.filter((n) => !n.read).length;
  }, [user]);

  const capitalize = (text) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";

  // Auto-close sidebar on mobile screen sizes
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (mobile && open) {
        // Automatically close sidebar on mobile
        dispatch(setSidebarOpen(false));
      }
    };

    // Check on mount
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [open, dispatch]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" sx={{ bgcolor: "white", color: "#1a1a1a" }}>
          <Toolbar style={{ backgroundColor: "white" }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => {
                dispatch(toggleSidebar());
              }}
              edge="start"
            >
              <MenuIcon />
            </IconButton>

            <Box
              component="img"
              sx={{
                height: 56,
                margin: 1,
              }}
              alt="Your logo."
              src={Logo}
            />

            <Container
              maxWidth="100vw"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: 0,
                margin: 0,
                maxWidth: "none",
              }}
            >
              <Typography
                sx={{}}
                variant="h6"
                noWrap
                component="div"
                marginTop={1}
              >
                Welcome{" "}
                {capitalize(
                  validateUser?.UserValidate?.data?.user?.type === "landlord"
                    ? "owner"
                    : validateUser?.UserValidate?.data?.user?.type
                )}
                ,{" "}
                {`${capitalize(
                  loginUser?.login?.data?.data?.name ||
                    validateUser?.UserValidate?.data?.user?.name ||
                    localStorage.getItem("name")
                )}`}
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                }}
                variant="h6"
                noWrap
                component="div"
              >
                <Tooltip title="Notifications">
                  <IconButton
                    color="inherit"
                    onClick={handleNotifClick}
                    aria-controls={notifOpen ? "notif-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={notifOpen ? "true" : undefined}
                  >
                    <Badge
                      color="error"
                      badgeContent={unreadCount > 0 ? unreadCount : 0}
                      invisible={unreadCount === 0}
                    >
                      <NotificationsIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>

                {/* 🔽 Notification Dropdown Menu */}
                <Menu
                  anchorEl={anchorNotif}
                  id="notif-menu"
                  open={notifOpen}
                  onClose={handleNotifClose}
                  PaperProps={{
                    elevation: 4,
                    sx: {
                      width: 320,
                      maxHeight: 400,
                      mt: 1.5,
                      overflowY: "auto",
                      "&::-webkit-scrollbar": { width: 6 },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#ccc",
                        borderRadius: 3,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, px: 2, pt: 1, pb: 0.5 }}
                  >
                    Notifications
                  </Typography>
                  <Divider />

                  {user?.notifications?.length > 0 ? (
                    user.notifications
                      .slice()
                      .reverse()
                      .map((notif, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => {
                            // Optional: mark as read or navigate
                            // handleNotifClose();
                            navigate("/notifications");
                          }}
                          sx={{
                            whiteSpace: "normal",
                            alignItems: "flex-start",
                            backgroundColor: notif.read ? "inherit" : "#f5f5f5",
                            borderBottom: "1px solid #eee",
                            "&:hover": { backgroundColor: "#e3f2fd" },
                          }}
                        >
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: notif.read ? 400 : 600 }}
                            >
                              {notif.message || "New notification"}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ mt: 0.3 }}
                            >
                              {new Date(notif.date).toLocaleString()}
                            </Typography>
                          </Box>
                        </MenuItem>
                      ))
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        p: 2,
                        textAlign: "center",
                        color: "text.secondary",
                      }}
                    >
                      No notifications yet.
                    </Typography>
                  )}
                </Menu>

                {/* PROFILE MENU */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                  }}
                >
                  <Tooltip title="Account settings">
                    <IconButton
                      onClick={handleClick}
                      size="small"
                      sx={{ ml: 2 }}
                      aria-controls={toogle ? "account-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={toogle ? "true" : undefined}
                    >
                      <Avatar
                        sx={{ width: 32, height: 32 }}
                        src={user?.profileImage}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>

                <Menu
                  anchorEl={anchorEl}
                  id="account-menu"
                  open={toogle}
                  onClose={handleClose}
                  onClick={handleClose}
                  slotProps={{
                    paper: {
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        "&::before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  {/* Tenant Menu */}
                  {validateUser?.UserValidate?.data?.user?.type ===
                    "tenant" && (
                    <>
                      <MenuItem
                        onClick={() => {
                          navigate("/tenant-profile");
                        }}
                      >
                        <ListItemIcon>
                          <Person fontSize="small" />
                        </ListItemIcon>
                        My Profile
                      </MenuItem>
                      <Divider />
                      <MenuItem onClick={() => setOpenDialog(true)}>
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                      </MenuItem>
                    </>
                  )}

                  {/* Landlord Menu */}
                  {validateUser?.UserValidate?.data?.user?.type ===
                    "landlord" && (
                    <>
                      <MenuItem
                        onClick={() => {
                          navigate("/profile");
                        }}
                      >
                        <ListItemIcon>
                          <Person fontSize="small" />
                        </ListItemIcon>
                        Profile
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate("/wallet");
                        }}
                      >
                        <ListItemIcon>
                          <Wallet fontSize="small" />
                        </ListItemIcon>
                        Wallet
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => {
                          navigate("/bank-detail");
                        }}
                      >
                        <ListItemIcon>
                          <MdAccountBalance size={20} />
                        </ListItemIcon>
                        Account Details
                      </MenuItem> */}
                      <Divider />
                      <MenuItem onClick={() => setOpenDialog(true)}>
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                      </MenuItem>
                    </>
                  )}

                  {/* Admin Menu */}
                  {validateUser?.UserValidate?.data?.user?.type === "admin" && (
                    <>
                      <MenuItem
                        onClick={() => {
                          navigate("/admin-dashboard");
                        }}
                      >
                        <ListItemIcon>
                          <Person fontSize="small" />
                        </ListItemIcon>
                        Dashboard
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <ListItemIcon>
                          <Settings fontSize="small" />
                        </ListItemIcon>
                        Settings
                      </MenuItem>
                      <Divider />
                      <MenuItem onClick={() => setOpenDialog(true)}>
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        Logout
                      </MenuItem>
                    </>
                  )}
                </Menu>
                {/* Profile Picture closed */}
              </Typography>
            </Container>
          </Toolbar>
        </AppBar>
        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={open}
          onClose={() => dispatch(setSidebarOpen(false))}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          {validateUser?.UserValidate?.data?.user?.type === "landlord" ? (
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/landlord-dashboard" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/landlord-dashboard");
                }}
              >
                <Tooltip title={!open ? "Dashboard" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                      marginTop: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <AiFillHome size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Dashboard" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/my-properties" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/my-properties");
                }}
              >
                <Tooltip title={!open ? "My Properties" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <MdApartment size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "My Properties" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/properties-setting" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/properties-setting");
                }}
              >
                <Tooltip title={!open ? "Properties Setting" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <MdSettings size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Properties Setting" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              {validateUser?.UserValidate?.data?.user?.requests?.length > 0 && (
                <>
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/add-new-tenant" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/add-new-tenant");
                    }}
                  >
                    <Tooltip
                      title={!open ? "Add New Tenant" : ""}
                      placement="right"
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <IoMdAdd size={20} />
                        </ListItemIcon>
                        <ListItemText
                          primary={open ? "Add New Tenant" : null}
                        />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/new-request" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/new-request");
                    }}
                  >
                    <Tooltip
                      title={!open ? "New Request" : ""}
                      placement="right"
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <GoGitPullRequest size={20} />
                        </ListItemIcon>
                        <ListItemText
                          primary={open ? "Tenant New Request" : null}
                        />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                </>
              )}
              {/* Rent tracking, rent collection, maintenance and My Tenants
                  only make sense once someone is actually living in a flat.
                  This used to open on a verified payment, which is a booking —
                  the owner got four menu items for a tenancy that had not
                  started, all of them empty. A booking that is still waiting on
                  its move-in does not count. */}
              {validateUser?.UserValidate?.data?.user?.requests?.some(
                (val) =>
                  val.paymentStatus === "verified" &&
                  val.moveInStatus !== "awaiting" &&
                  val.moveInStatus !== "cancelled"
              ) && (
                <>
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/rent-tracker" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/rent-tracker");
                    }}
                  >
                    <Tooltip
                      title={!open ? "Rent Tracker" : ""}
                      placement="right"
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <MdAccountBalance size={20} />
                        </ListItemIcon>
                        <ListItemText primary={open ? "Rent Tracker" : null} />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/rent-collection" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/rent-collection");
                    }}
                  >
                    <Tooltip
                      title={!open ? "Rent Collection" : ""}
                      placement="right"
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <Payment size={20} />
                        </ListItemIcon>
                        <ListItemText
                          primary={open ? "Rent Collection" : null}
                        />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>

                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/escrow-management" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/escrow-management");
                    }}
                  >
                    <Tooltip title={!open ? "Escrow" : ""} placement="right">
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <Lock size={20} />
                        </ListItemIcon>
                        <ListItemText
                          primary={open ? "Escrow Management" : null}
                        />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>

                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/maintenance-request" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/maintenance-request");
                    }}
                  >
                    <Tooltip
                      title={!open ? "Maintenance Request" : ""}
                      placement="right"
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <Engineering size={20} />
                        </ListItemIcon>
                        <ListItemText
                          primary={open ? "Maintenance Request" : null}
                        />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                  {/* No "Interest Requests" entry here. It would be a second
                      door onto the same data as "Tenant New Request", which is
                      where the whole booking journey now lives — new request,
                      payment verification, move-in confirmation. Two menu
                      items for one job is how an owner ends up not knowing
                      which page does what. */}
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/my-tenants" ||
                      mylocation.includes("landlord-functionality") ||
                      mylocation.includes("agreement") ||
                      mylocation.includes("upload-Bill") ||
                      mylocation.includes("pending-bill") ||
                      mylocation.includes("previous-bill")
                        ? "active-li"
                        : ""
                    }`}
                    onClick={() => {
                      navigate("/my-tenants");
                    }}
                  >
                    <Tooltip
                      title={!open ? "My Tenants" : ""}
                      placement="right"
                    >
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <IoIosPeople size={20} />
                        </ListItemIcon>
                        <ListItemText primary={open ? "My Tenants" : null} />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                </>
              )}

              {/* <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/bank-detail" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/bank-detail");
                }}
              >
                <Tooltip
                  title={!open ? "Account Detail" : ""}
                  placement="right"
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <MdAccountBalance size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Account Detail" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem> */}

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/notifications" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/notifications");
                }}
              >
                <Tooltip title={!open ? "Notifications" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <MdNotifications size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Notifications" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                onClick={() => setOpenDialog(true)}
              >
                <Tooltip title={!open ? "Logout" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <Logout size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Logout" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
            </List>
          ) : validateUser?.UserValidate?.data?.user?.type === "tenant" ? (
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/tenant-dashboard" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/tenant-dashboard");
                }}
              >
                <Tooltip title={!open ? "Dashboard" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                      marginTop: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <AiFillHome size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Dashboard" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/find-property" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/find-property");
                }}
              >
                <Tooltip title={!open ? "Find Property" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <MdApartment size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Find Property" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              {validateUser?.UserValidate?.data?.tenantProfile
                ?.flatInterestRequests?.length > 0 && (
                <ListItem
                  disablePadding
                  sx={{ display: "block" }}
                  className={`${
                    mylocation === "/my-requests" ? "active-li" : ""
                  }`}
                  onClick={() => {
                    navigate("/my-requests");
                  }}
                >
                  <Tooltip title={!open ? "My Requests" : ""} placement="right">
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <MdAssignment size={20} />
                      </ListItemIcon>
                      <ListItemText primary={open ? "My Requests" : null} />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}

              {validateUser?.UserValidate?.data?.user?.is_tenant && (
                <ListItem
                  disablePadding
                  sx={{ display: "block" }}
                  className={`${
                    mylocation.includes("/tenant-functionality") ? "active-li" : ""
                  }`}
                  onClick={() => {
                    navigate(
                      `/tenant-functionality/${validateUser?.UserValidate?.data?.tenantProfile?.propertyDetail?.[0]?.landlordId}/${validateUser?.UserValidate?.data?.tenantProfile?.propertyDetail?.[0]?._id}`
                    );
                  }}
                >
                  <Tooltip
                    title={!open ? "My Rent Flat" : ""}
                    placement="right"
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      >
                        <MdApartment size={20} />
                      </ListItemIcon>
                      <ListItemText primary={open ? "My Rent Flat" : null} />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              )}

              {/* Pay Rent - Only show if tenant has active tenancy */}
              {validateUser?.UserValidate?.data?.tenantProfile?.propertyDetail
                ?.length > 0 &&
                localStorage.getItem("is_register") === "true" &&
                localStorage.getItem("is_active") === "true" && (
                  <ListItem
                    disablePadding
                    sx={{ display: "block" }}
                    className={`${
                      mylocation === "/rent-payment" ? "active-li" : ""
                    }`}
                    onClick={() => {
                      navigate("/rent-payment");
                    }}
                  >
                    <Tooltip title={!open ? "Pay Rent" : ""} placement="right">
                      <ListItemButton
                        sx={{
                          minHeight: 48,
                          justifyContent: open ? "initial" : "center",
                          px: 2.5,
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: open ? 3 : "auto",
                            justifyContent: "center",
                          }}
                        >
                          <Payment size={20} />
                        </ListItemIcon>
                        <ListItemText primary={open ? "Pay Rent" : null} />
                      </ListItemButton>
                    </Tooltip>
                  </ListItem>
                )}

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/tenant-profile" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/tenant-profile");
                }}
              >
                <Tooltip title={!open ? "My Profile" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <Person size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "My Profile" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                onClick={() => setOpenDialog(true)}
              >
                <Tooltip title={!open ? "Logout" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <Logout size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Logout" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
            </List>
          ) : (
            <List>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/admin-dashboard" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/admin-dashboard");
                }}
              >
                <Tooltip title={!open ? "Dashboard" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                      marginTop: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <AiFillHome size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Dashboard" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              {/* <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/landlord-dashboard" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/landlord-dashboard");
                }}
              >
                <Tooltip title={!open ? "Dashboard" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                      marginTop: 2,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <AiFillHome size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Dashboard" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/add-new-tenant" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/add-new-tenant");
                }}
              >
                <Tooltip
                  title={!open ? "Add New Tenant" : ""}
                  placement="right"
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <IoMdAdd size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Add New Tenant" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/new-request" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/new-request");
                }}
              >
                <Tooltip title={!open ? "New Request" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <GoGitPullRequest size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "New Request" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/my-tenants" ||
                  mylocation.includes("landlord-functionality") ||
                  mylocation.includes("agreement") ||
                  mylocation.includes("upload-Bill") ||
                  mylocation.includes("pending-bill") ||
                  mylocation.includes("previous-bill")
                    ? "active-li"
                    : ""
                }`}
                onClick={() => {
                  navigate("/my-tenants");
                }}
              >
                <Tooltip title={!open ? "My Tenants" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <IoIosPeople size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "My Tenants" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                className={`${
                  mylocation === "/bank-detail" ? "active-li" : ""
                }`}
                onClick={() => {
                  navigate("/bank-detail");
                }}
              >
                <Tooltip
                  title={!open ? "Account Detail" : ""}
                  placement="right"
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <MdAccountBalance size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Account Detail" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem> */}

              <ListItem
                disablePadding
                sx={{ display: "block" }}
                onClick={() => setOpenDialog(true)}
              >
                <Tooltip title={!open ? "Logout" : ""} placement="right">
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      <Logout size={20} />
                    </ListItemIcon>
                    <ListItemText primary={open ? "Logout" : null} />
                  </ListItemButton>
                </Tooltip>
              </ListItem>
            </List>
          )}
          <Divider />
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3, marginTop: 5 }}></Box>
      </Box>
      <LogoutDialog open={openDialog} onClose={() => setOpenDialog(false)} />
    </>
  );
}
